import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    company_account_period_query,
    company_account_period_create,
    company_account_period_update_flag,
    contract_check_add_payment,
    es_query_mine_contract,
    placing_ads_record_select_search,
    expense_group_save_placing_records,
    expense_group_related_placing_records,
    expense_group_delete_placing_records,
    placing_ads_vas_record_select_search,
    epop_account_share_save_config,
    epop_account_share_list_config
 } = util.api || {}

 export function getCompanyAccountPeriodQueryApi(params) {
    return http.get(company_account_period_query, params)
}

export function saveCompanyAccountPeriodApi(params) {
    return http.post(company_account_period_create, params)
}

export function changeCompanyAccountFlagApi(params) {
    return http.post(company_account_period_update_flag, params)
}


export function getPlacingAdsRecordSelectSearchApi(params) {
    return http.get(placing_ads_record_select_search, params)
}

export function postExpenseGroupSavePlacingAdsApi(params) {
    return http.post(expense_group_save_placing_records, params)
}

export function getPlacingAdsListApi(params) {
    return http.get(expense_group_related_placing_records, params)
}

export function postExpenseGroupDeletePlacingAdsApi(params) {
    return http.post(expense_group_delete_placing_records, params)
}

export function getPlacingAdsVasRecordSelectSearchApi(params) {
    return http.get(placing_ads_vas_record_select_search, params)
}

export function getEpopAccountShareListConfigApi() {
    return http.get(epop_account_share_list_config)
}

export function postEpopAccountShareSaveConfigApi(params) {
    return http.post(epop_account_share_save_config, params)
}